import React from 'react';
import styled from 'styled-components';
import { ClockConfigType } from '../config/letters/config.types';
import { CONFIG_MAP } from '../config/letters/config.map';
import { SKIN_LETTER_MAP } from '../config/skins/skins.map';
import { SkinType } from '../config/skins/skins.types';
import { REPLACEMENT_MAP } from '../config/letters/replacementMap';

interface Props {
  activeChars: number[];
  skin: SkinType;
  configType: ClockConfigType;
}

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const Letter = styled.div<{ $isActive: boolean; $skin: SkinType }>`
  text-transform: uppercase;
  font-size: 1.3rem;
  font-family: arial, sans-serif;
  display: flex;
  justify-content: center;
  width: 100%;
  transition:
    opacity 0.5s ease-out,
    color 0.5s ease-out;

  @media screen and (max-width: 800px) {
    font-size: 1rem;
  }

  @media screen and (max-height: 500px) {
    font-size: 0.9rem;
  }

  ${props => SKIN_LETTER_MAP[props.$skin]}
`;

const LENGTH_MAP: Record<ClockConfigType, number> = {
  russian: 14,
  german: 10,
  english: 10,
};

const replaceSpecialChars = (str: string) =>
  str.replace(/Æ/g, match => REPLACEMENT_MAP[match] || match);

function ClockRows({ configType, skin, activeChars }: Props) {
  const activeSet = new Set(activeChars);

  return (
    <>
      {Array.from({ length: LENGTH_MAP[configType] }, (_, rowIndex) => {
        const lettersRows = CONFIG_MAP[configType].slice(rowIndex * 11, rowIndex * 11 + 11);

        return (
          <Row key={rowIndex}>
            {lettersRows.map((letter, letterIndex) => {
              const globalIndex = rowIndex * 11 + letterIndex;
              const isActive = activeSet.has(globalIndex); // schneller
              return (
                <Letter key={letterIndex} $isActive={isActive} $skin={skin}>
                  {replaceSpecialChars(letter)}
                </Letter>
              );
            })}
          </Row>
        );
      })}
    </>
  );
}

export default ClockRows;
